"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const AlarmIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.94455 3.441L6.66335 1.9052L2.05605 5.7488L3.33715 7.2846L7.94455 3.441ZM17.3365 1.9058L21.9439 5.7494L20.6627 7.2852L16.0553 3.4416L17.3365 1.9058ZM12.5 8.0948H11V14.0948L15.75 16.9448L16.5 15.7148L12.5 13.3448V8.0948ZM12 4.0948C7.03005 4.0948 3.00005 8.1248 3.00005 13.0948C3.00005 18.0648 7.03005 22.0948 12 22.0948C16.97 22.0948 21 18.0648 21 13.0948C21 8.1248 16.97 4.0948 12 4.0948ZM5.00005 13.0948C5.00005 16.9548 8.14005 20.0948 12 20.0948C15.86 20.0948 19 16.9548 19 13.0948C19 9.2348 15.86 6.0948 12 6.0948C8.14005 6.0948 5.00005 9.2348 5.00005 13.0948Z",
  fill: "currentColor"
}));

var _default = AlarmIcon;
exports.default = _default;